
  <h1>Summary</h1>

  <br />
  <div class="col-md-12" style="background-color:#fff;margin-top:10px;">
    <div *ngFor="let summery of AutomationSummery">
      <div class="form-row">
        <div class="form-group col">
          <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
            <div style="position: relative;">
              <h5>  <span>Automation Name</span></h5>
            </div>
            <div style="position: relative;">
              <h5>    <span>{{ summery.automationName }}</span></h5>
            </div>

          </div>
        </div>

      </div>

      <div class="form-row" >

        <div class="form-group col">
          <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
            <div style="position: relative;">
              <h5> <span>Trigger Connector</span> </h5>
            </div>
            <div style="position: relative;">
              <h5>   <span><img src="{{ url + summery.triggerConnectorLogo}}" class="img-fluid" width="100" />{{ summery.triggerConnectorName }}</span></h5>
            </div>

          </div>
        </div>
      </div>
      <div class="form-row">

        <div class="form-group col">
          <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
            <div style="position: relative;">
              <h5>    <span>Trigger Event</span></h5>
            </div>
            <div style="position: relative;">
              <h5>   <span>{{ summery.triggerEvent }}</span></h5>
            </div>

          </div>
        </div>
      </div>

      <div class="form-row">

        <div class="form-group col">
          <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
            <div style="position: relative;">
              <h5>  <span>Action Connector</span></h5>
            </div>
            <div style="position: relative;">
              <h5>   <span><img src="{{ url + summery.actionConnectorLogo}}" class="img-fluid" width="100" />{{ summery.actionConnectorName }}</span></h5>
            </div>

          </div>
        </div>
      </div>

      <div class="form-row">

        <div class="form-group col">
          <div style="    display: grid;    grid-template-columns: 200px auto;    gap: 15px;">
            <div style="position: relative;">
              <h5>     <span>Action </span></h5>
            </div>
            <div style="position: relative;">
              <h5>    <span>{{ summery.actionEvent }}</span></h5>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
